export const getCavaData = () => ({
  name: "Cava",
  country: "Espagne",
  description: "Le Cava est une appellation de vins effervescents espagnols, principalement produite en Catalogne. Ces vins sont élaborés selon la méthode traditionnelle, comme le champagne, et offrent une excellente alternative aux vins effervescents français.",
  type: "region",
  mapAreas: [
    { region: "Cava", x: 52, y: 55, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "32,000 ha",
    production: "250 million bottles",
    appellations: "159 communes",
    regions: "8 régions",
    exportPercentage: "65%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré avec influence maritime",
    soil: "Sols calcaires et argileux, excellents pour la rétention d'eau",
    viticulture: "Viticulture traditionnelle, méthode traditionnelle, vendanges manuelles"
  },
  wineStyles: {
    brut: "Cava sec et équilibré, parfait pour l'apéritif",
    extra_brut: "Cava très sec, pour les amateurs de vins secs",
    sec: "Cava légèrement doux, pour accompagner les desserts",
    rose: "Cava rosé, élégant et fruité",
    vintage: "Cava de millésime, complexe et de garde"
  },
  history: "La production de vins effervescents en Espagne remonte au XIXe siècle. Le Cava a été créé en 1972 comme appellation d'origine. Aujourd'hui, le Cava est reconnu comme l'un des meilleurs vins effervescents du monde.",
  foodPairing: "Apéritifs, fruits de mer, volailles, fromages affinés, desserts",
  subregions: {
    "penedes": {
      name: "Penedès",
      description: "Région principale du Cava produisant des vins effervescents de qualité, avec une forte identité catalane.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, méthode traditionnelle"
      },
      grapeVarieties: {
        white: ["Macabeo", "Xarel·lo", "Parellada", "Chardonnay"],
        red: ["Garnacha", "Monastrell", "Pinot Noir"]
      },
      wineStyles: {
        "cava-penedes": "Vins effervescents secs et équilibrés",
        "cava-rose-penedes": "Vins effervescents rosés élégants"
      },
      foodPairing: "Apéritifs, fruits de mer, volailles, cuisine catalane"
    },
    "ecija": {
      name: "Écija",
      description: "Région andalouse produisant des Cavas de qualité, avec une forte identité méridionale.",
      characteristics: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Macabeo", "Xarel·lo", "Parellada"],
        red: ["Garnacha", "Monastrell"]
      },
      wineStyles: {
        "cava-ecija": "Vins effervescents secs et fruités",
        "cava-rose-ecija": "Vins effervescents rosés fruités"
      },
      foodPairing: "Apéritifs, tapas, cuisine andalouse"
    },
    "valencia": {
      name: "Valence",
      description: "Région valencienne produisant des Cavas équilibrés et accessibles.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols calcaires et sableux",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        white: ["Macabeo", "Xarel·lo", "Parellada"],
        red: ["Garnacha", "Monastrell"]
      },
      wineStyles: {
        "cava-valencia": "Vins effervescents équilibrés et accessibles",
        "cava-rose-valencia": "Vins effervescents rosés frais"
      },
      foodPairing: "Apéritifs, poissons, volailles, cuisine valencienne"
    },
    "aragon": {
      name: "Aragon",
      description: "Région aragonaise produisant des Cavas de qualité, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vignobles en altitude"
      },
      grapeVarieties: {
        white: ["Macabeo", "Xarel·lo", "Parellada"],
        red: ["Garnacha", "Monastrell"]
      },
      wineStyles: {
        "cava-aragon": "Vins effervescents secs et structurés",
        "cava-rose-aragon": "Vins effervescents rosés complexes"
      },
      foodPairing: "Apéritifs, viandes rouges, fromages, cuisine aragonaise"
    }
  }
}); 